var _defs, _g, _path, _path2, _path3, _path4, _path5, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSwipe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 180 390",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 390,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -9,
    width: 188,
    height: 408,
    fill: "none"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_swipe_v") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180,300V90A90,90,0,0,0,0,90V300a90,90,0,0,0,180,0",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.2,125.2l6,4.1c-.2.3-.5.6-.9,1.1a14.37,14.37,0,0,0-1.5,2.7,9.52,9.52,0,0,0-.9,3.8,4.75,4.75,0,0,0,.6,2.4,2.12,2.12,0,0,0,2,1,2.08,2.08,0,0,0,1.6-1.1,11.28,11.28,0,0,0,1.4-2.7c.4-1.1.9-2.2,1.5-3.5a29.13,29.13,0,0,1,2-3.5,8.38,8.38,0,0,1,2.9-2.7,8.21,8.21,0,0,1,4.2-1.1,8.77,8.77,0,0,1,7.1,3.3,12.37,12.37,0,0,1,2.7,8.1,16.86,16.86,0,0,1-.9,5.6,11.83,11.83,0,0,1-1.8,3.6l-.9,1.1-6.4-3.3a11.49,11.49,0,0,0,.8-1,24.43,24.43,0,0,0,1.3-2.5,9.37,9.37,0,0,0,.8-3.6,4.75,4.75,0,0,0-.6-2.4,2.06,2.06,0,0,0-1.9-1,2.28,2.28,0,0,0-1.9,1.5,30.82,30.82,0,0,0-1.7,3.6c-.5,1.4-1.2,2.8-1.9,4.3a10.64,10.64,0,0,1-3.1,3.6,8.14,8.14,0,0,1-4.9,1.5,9.19,9.19,0,0,1-7.1-3.1,11.64,11.64,0,0,1-2.9-8.3,18.41,18.41,0,0,1,.5-4.1,18.16,18.16,0,0,1,1.1-3.3c.5-.9.9-1.7,1.3-2.4a7,7,0,0,1,1.2-1.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1,158.7l32.2-7.8v8.3l-20.1,4c-.6.1-1.2.2-1.7.3a6.82,6.82,0,0,1-1.2.1h-.4v.1a16.39,16.39,0,0,1,3.4.5l20.1,4.9v6.3l-20.1,4.8c-.6.1-1.2.3-1.7.4a7.07,7.07,0,0,0-1.2.2H82v.1a15.46,15.46,0,0,1,3.4.4l20.1,4.4v8.1l-32.2-8.1V177l16.2-4,3.8-.6v-.1a32.62,32.62,0,0,1-3.8-.6l-16.2-4v-9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1,198.6h32.2v7.9H73.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1,214h32.2v13.4a10,10,0,0,1-3.1,7.6,12.48,12.48,0,0,1-16,0,9.81,9.81,0,0,1-3.1-7.6v-5.5H73.2V214Zm16.7,7.9v3.9a3.77,3.77,0,0,0,1.2,3,4.77,4.77,0,0,0,3.2,1.1,4.29,4.29,0,0,0,3.1-1,4.07,4.07,0,0,0,1.2-2.9v-4H89.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1,242.5h32.2v20.2H98.5V250.4H92.7v9.8H85.9v-9.8H79.8v12.9H73V242.5Z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.5,300a2.73,2.73,0,0,1,1.9.8L90,313.4l12.6-12.6a2.76,2.76,0,0,1,3.9,3.9L92,319.2a2.72,2.72,0,0,1-3.9,0L73.6,304.7a2.75,2.75,0,0,1,1.9-4.7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.5,90a2.73,2.73,0,0,1-1.9-.8L90,76.6,77.4,89.2a2.76,2.76,0,0,1-3.9-3.9L88,70.8a2.72,2.72,0,0,1,3.9,0l14.5,14.5a2.75,2.75,0,0,1-1.9,4.7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSwipe);
export default __webpack_public_path__ + "static/media/ic_swipe.f4d070e93d5c9a9077d0906b55100435.svg";
export { ForwardRef as ReactComponent };